export enum WeekJumpType {
    PreviousWeek = 0,
    FourWeeksBack = 1,
    NextWeek = 2,
    FourWeeksForward = 3
}